import { render, staticRenderFns } from "./ListaDentista.vue?vue&type=template&id=579fd757&scoped=true&"
import script from "./ListaDentista.vue?vue&type=script&lang=js&"
export * from "./ListaDentista.vue?vue&type=script&lang=js&"
import style0 from "./ListaDentista.vue?vue&type=style&index=0&id=579fd757&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579fd757",
  null
  
)

export default component.exports